module.exports = __webpack_public_path__ + "static/media/Camila_Montandon_Alinhamento.fa224b68.jpg";